import Request from '~/providers/Request';

export const fetchUsers = async (input, page, resolve) => {
  await Request.get(`/admin/users?sorter=name.asc&qs=${input}&page=${page}`).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}${e.email ? ` <${e.email}>` : ''}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
